// extracted by mini-css-extract-plugin
export default {"description":"FlagsList_description__YhvWA","value":"FlagsList_value__rpGxA","ellipsis":"FlagsList_ellipsis__mFJhY"};